<script>
    import { onMount } from 'svelte';
    import { goto } from '@roxi/routify';
    import Chart from 'chart.js/auto';
    import chartService from '../../../../services/chart.js';

    export let cves = [];

    let canvas;
    let chart;
    let has_data = null;

    let chartColors = {
        critical: chartService.colors.critical,
        high    : chartService.colors.high,
        medium  : chartService.colors.medium,
        low     : chartService.colors.low
    }

    onMount(async () => {
        let ctx  = canvas.getContext('2d');

        if(cves.length){
            has_data = true;
        }

        let cveTops     = cves.splice(0, 10);
        let cveOtherSum = cves.reduce((acc, cve) => acc + cve.count, 0);

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : [],
                borderColor     : '#fff',
                borderWidth     : 1,
                title: [],
                data: []
            },
        }

        cveTops.forEach(cveTop => {
            cveTop.color          = chartColors[cveTop.level];
            return cveTop;
        });

        cveTops = cveTops.sort((a, b) => {
           if(a.priority > b.priority && a.level != b.level) return -1;
           if(a.priority < b.priority && a.level != b.level) return 1;
           if(a.level == b.level) {
               return b.count - a.count;
           }

        });

        cveTops.forEach(cveTop => {
            chartData.datasets.backgroundColor.push(cveTop.color);
            chartData.labels.push(`${cveTop.key}`);
            chartData.datasets.title.push(cveTop.description);
            chartData.datasets.data.push(cveTop.count);
        });

        chart = new Chart(ctx, {
            type: 'polarArea',
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    rectangle: {
                        borderWidth: 2,
                    }
                },
                responsive: true,
                plugins: {
                    legend: {
                        position: 'right',
                        fontFamily: 'Montserrat'
                    },
                    title: {
                        display: false,
                        text: 'Chart.js Horizontal Bar Chart'
                    },
                    tooltip:{
                        callbacks: {
                            title: function(tooltipItem) {
                                let index = tooltipItem[0].dataIndex;
                                let title = tooltipItem[0].dataset.title[index]
                                return title;
                            }
                        }
                    },
                },
                scales: {
                    r: {
                        grid: {
                            color: "#666",
                            font: {
                                size: 16,
                                color: '#666'
                            }
                        },
                    }
                },
                onHover : (event) => {
                    if((event.chart.tooltip.title && event.chart.tooltip.title != "Otros")){
                        canvas.style.cursor =  "pointer";
                    }
                    else{
                        canvas.style.cursor = "default";
                    }
                },
                onClick : (event) => {
                    if (!event.chart.tooltip.title || event.chart.tooltip.title == "Otros" ) return;
                    let url = "/vulnerability/" + event.chart.tooltip.dataPoints[0].label;
                    $goto(url);
                },
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });
</script>
<style>
    #chart-top-cve {
        height: 480px !important;
        margin: 0 auto;
    }
</style>
<canvas bind:this={canvas} id="chart-top-cve" class:chart-has-no-data="{!has_data}"></canvas>
